import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { UserSettingsModule as SharedUserSettingsModule } from '@nimbus-library/features/user-settings/user-settings.module';
import { DefaultUserSettingsStatusService } from '@nimbus-library/features/user-settings/services/defaults/default-user-settings-status.service';
import { RunbookService } from '@nimbus-global/features/settings/services/runbook.service';
import { ProfilePictureService } from '@nimbus-global/features/reporting/services/storage/profile-picture.service';
import { AcUserProfileState } from '@nimbus-portal/features/attendant-console/store/ac-user-profile/ac-user-profile.state';
import { AcO365LicenseResolver } from '@nimbus-portal/features/attendant-console/services/ac-o365-license-resolver';
import { FeaturePermissionModule } from '../feature-permission/feature-permission.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FeaturePermissionModule,
    NgxsModule.forFeature([AcUserProfileState]),
    SharedUserSettingsModule.forRoot(
      {
        disableLanguageSelector: false,
        hideFeatureList: false,
        hideLicenseList: false,
        hideRunbookInformation: false,
      },
      DefaultUserSettingsStatusService,
      ProfilePictureService,
      RunbookService,
    ),
  ],
  providers: [AcO365LicenseResolver],
  exports: [FeaturePermissionModule, SharedUserSettingsModule],
})
export class UserSettingsModule {}
